import { Box, Stack, Typography, Button, Drawer, Divider } from "@compass/core";
import { ListFilterBase } from "generated/openApi";
import { ReactNode } from "react";

interface FilterDrawerProps<T> {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  onReset: () => void;
  children: ReactNode;
  listFilter: T;
}

export const FilterDrawer = <T extends ListFilterBase>(props: FilterDrawerProps<T>) => {
  return (
    <Drawer
      anchor="right"
      open={props.open}
      onClose={props.onClose}
      PaperProps={{
        sx: {
          width: 900,
        },
      }}
    >

      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          px: 3,
          py: 2,
        })}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Filters
          </Typography>

          <Stack direction="row" sx={{ gap: 1 }}>
            <Button
              variant="outlined"
              color="info"
              size="small"
              onClick={props.onReset}
            >
              Reset
            </Button>

            <Button
              variant="outlined"
              color="info"
              size="small"
              onClick={props.onApply}
              sx={(theme) => ({
                backgroundColor: theme.palette.common.white,
                color: theme.palette.primary.main,
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#f4f6f8",
                },
              })}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              color="info"
              size="small"
              onClick={props.onClose}
              sx={(theme) => ({
                backgroundColor: theme.palette.common.white,
                color: theme.palette.primary.main,
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#f4f6f8",
                },
              })}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>


      <Box sx={{ flex: 1, overflowY: "auto" }}>
        {props.children}
      </Box>
 
              {/* Insert Tabs Here */}

       {/* <Divider sx={{ my: 2 }} />

      <Box sx={{px: 2, paddingBottom: 2}}>
        <Typography variant="subtitle2">Applied Filters</Typography>
        <Typography variant="body2" color="text.secondary">
          (Linking this up to filter state to display applied filters here)
        </Typography>
        <Button variant="outlined" size="small" onClick={props.onReset}>
          Reset all
        </Button>
      </Box>  */}
    </Drawer>
  );
};
